import * as types from '../mutation-types';
import TicketsAPI from '../../api/tickets';

const state = {
  records: {},
  uiFlags: { isFetching: false },
};

export const getters = {
  getByTicketId: $state => ticketId => {
    const conversations = $state.records[ticketId] || [];
    return [...conversations].sort(
      (a, b) => new Date(a.created_at) - new Date(b.created_at)
    );
  },
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  fetch: async ({ commit }, ticketId) => {
    commit(types.default.SET_TICKET_CONVERSATIONS_UI_FLAG, {
      isFetching: true,
    });
    try {
      const { data } = await TicketsAPI.getConversations(ticketId);
      commit(types.default.SET_TICKET_CONVERSATIONS, {
        ticketId,
        data: data || [],
      });
    } catch (error) {
      // Handle error
    } finally {
      commit(types.default.SET_TICKET_CONVERSATIONS_UI_FLAG, {
        isFetching: false,
      });
    }
  },
  create: async (
    { commit },
    { ticketId, message, isPrivate, clientVisible }
  ) => {
    const { data } = await TicketsAPI.createConversation(
      ticketId,
      message,
      isPrivate,
      clientVisible
    );
    commit(types.default.ADD_TICKET_CONVERSATION, {
      ticketId,
      data,
    });
    return data;
  },
  addConversation: ({ commit }, data) => {
    const ticketId = data.ticket_display_id || data.ticket_id;
    if (ticketId) {
      commit(types.default.ADD_TICKET_CONVERSATION, { ticketId, data });
    }
  },
};

export const mutations = {
  [types.default.SET_TICKET_CONVERSATIONS]: ($state, { ticketId, data }) => {
    $state.records = {
      ...$state.records,
      [ticketId]: data,
    };
  },
  [types.default.ADD_TICKET_CONVERSATION]: ($state, { ticketId, data }) => {
    const existing = $state.records[ticketId] || [];
    const alreadyExists = existing.some(c => c.id === data.id);
    if (!alreadyExists) {
      $state.records = {
        ...$state.records,
        [ticketId]: [...existing, data],
      };
    }
  },
  [types.default.SET_TICKET_CONVERSATIONS_UI_FLAG]: ($state, flags) => {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
